<template>
    <div class="top-menu-subgroup">
        <span class="subgroup-name" v-if="name">
            <img v-if="icon" :src="icon" width="24" height="24" style="margin-right: 4px;"/> 
            <span v-else class="no-image"></span>
            {{ name }}
        </span>
        <div class="items">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ["name", "icon"],
    components: {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>

<style lang="scss" scoped>
.top-menu-subgroup {
    padding: 16px;
    .subgroup-name {
        font-weight: 600;
        font-size: 1.1em;
    }
    .items {
        display: flex;
        flex-direction: column;
        column-count: 2;
        margin-top: 8px;
        gap: 8px;
        line-height: 1.2;
    }
}
.no-image {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 4px;
}

</style>